import { render, staticRenderFns } from "./Roles_mobile.vue?vue&type=template&id=09c8950a&scoped=true"
import script from "./Roles_mobile.vue?vue&type=script&lang=js"
export * from "./Roles_mobile.vue?vue&type=script&lang=js"
import style0 from "./Roles_mobile.vue?vue&type=style&index=0&id=09c8950a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8950a",
  null
  
)

export default component.exports